<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入专题id" v-model="params.sectionid" clearable size="small" class="param-input"></el-input>
      <el-input placeholder="请输入视频id" v-model="params.videoid" clearable size="small" class="param-input"></el-input>
      <el-button type="primary" size="small" icon="el-icon-search" @click="getVideos('status')" style="margin-right: 20px">搜索</el-button>
      <el-button type="primary" size="small" @click="addAndEdit('add')" style="margin-right: 20px">新增</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" ref="multipleTable" height="600">
      <el-table-column prop="id" label="ID" align="center" width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.title || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="moduleName" label="模块名称" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.moduleName || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cover" label="封面" align="center" min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.cover === ''" style="color: #838F9B">暂无图片</span>
          <decrypt-img
            v-else
            style="width: 70px; height: 70px"
            :src="imgUrl + scope.row.cover"
            fit="fill">
          </decrypt-img>
        </template>
      </el-table-column>
      <el-table-column prop="sectionID" label="专题ID" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.sectionID || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="subModuleName" label="亚模块名称" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.subModuleName || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sectionID" label="专题ID" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.sectionID || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="publisherID" label="发布者ID" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.publisherID || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sectionName" label="专题名称" align="center" min-width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.sectionName || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="videoID" label="视频id" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.videoID || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sortCode" label="视频排序" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.sortCode }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="success" icon="el-icon-edit" @click="addAndEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" background 
      @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @before-close="handleClose" @close="handleClose">
      <el-form :model="form" label-width="80px" :rules="rules" ref="form">
        <el-form-item label="专题id" prop="sectionID">
          <el-input v-model="form.sectionID" :disabled="sectionIdDisabled"></el-input>
        </el-form-item>
        <el-form-item label="视频id" prop="videoIDs">
          <el-input type="textarea" rows="5" v-model="form.videoIDs" :disabled="videoIdsDisabled"></el-input>
        </el-form-item>
        <el-form-item label="视频排序" prop="sortCode" v-if="isSortCode">
          <el-input v-model.number="form.sortCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api';
import { uniteDate } from '@/utils/validator.js';
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10
      },
      form: {
        sectionID: '',
        videoIDs: '',
        sortCode: ''
      },
      dialogVisible: false,
      dialogTitle: '',
      rules: {
        sectionID: [
          { required: true, message: '请输入专题id', trigger: 'blur' }
        ],
        videoIDs: [
          { required: true, message: '请输入视频id', trigger: 'blur' }
        ]
      },
      sectionIdDisabled: false,
      videoIdsDisabled: false,
      isSortCode: false,
      imgUrl: baseConfig.imgUrl
    };
  },
  created() {
    this.getVideos();
  },
  methods: {
    // 请求列表
    getVideos(type) {
      this.loading = false;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getVideos(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增专题配置
    addAndEdit(param) {
      this.dialogVisible = true;  // 打开新增、编辑对话框
      if(param === 'add') {
        this.dialogTitle = '批量新增'
      } else {
        this.dialogTitle = '编辑'
        // 把数据回显给表单
        this.form.sectionID = param.sectionID;
        this.form.videoIDs = param.videoID;
        this.form.sortCode = param.sortCode;
        this.form.id = param.id;
        this.sectionIdDisabled = true;
        this.videoIdsDisabled = true;
        this.isSortCode = true;
      }
    },
    // 新增、修改提交
    onSubmit() {
      if(this.dialogTitle === '批量新增') {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          var videoIDs = this.form.videoIDs.toString();
          //去掉空格
          videoIDs = videoIDs.replace(/\s+/g,"");
          //去掉换行符
          videoIDs = videoIDs.replace(/[\r\n]/g,"");
          //去掉两头逗号
          videoIDs = videoIDs.replace(/^,+/,"").replace(/,+$/,""); 
          let addData = {
            sectionID: this.form.sectionID,
            videoIDs: videoIDs,
          };
          API.batch(addData)
            .then((res) => {
              if(res.code === 200) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.handleClose();
                this.getVideos();
              } else {
                this.$message({
                  type: 'error',
                  message: '新增失败'
                })
              }
            }).catch(() => {

            })
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let req = {
            id: this.form.id,
            sectionID: this.form.sectionID,
            sortCode: this.form.sortCode
          }
          API.editVideo(req)
            .then((res) => {
              if(res.code === 200) {
                this.$message({
                  type: 'success',
                  message: '编辑成功'
                })
                this.handleClose();
                this.getVideos();
              } else {
                this.$message({
                  type: 'error',
                  message: '编辑失败'
                })
              }
            })
        } else {
          return false;
        }
      });
    },
    // 删除方法
    del(param) {
      this.$confirm(`确认是否删除<span style='color:blue'>${param.moduleName}</span>, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        let delData = {
          id: param.id
        }
        API.deleteVideo(delData).then((res) => {
          if(res.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'success',
              message: '删除失败!'
            });
          }
          this.getVideos();
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '服务器异常!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.sectionID = '';
      this.form.videoIDs = '';
      this.dialogVisible = false;
      this.sectionIdDisabled = false;
      this.videoIdsDisabled = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getVideos();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getVideos();
    }
  },
};
</script>

<style lang="scss" scoped>
  .dialog-footer {
    position: relative;
    left: 50%;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
  }
</style>
